<template>
  <el-scrollbar :native="false" style="width: 100%; height: 100%">
    <el-main
      id="page-back-member"
      v-loading="loading"
      element-loading-text="请稍后..."
    >
      <div class="screen-form">
        <div class="top-warp">
          <el-input
            v-model="searchInfo.phoneNumber"
            placeholder="请输入手机号"
            prefix-icon="el-icon-search"
            style="margin-right: 15px; width: 300px"
          ></el-input>
          <el-button type="primary" @click="searchClick">搜索</el-button>
        </div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="openDialog">开通会员</el-button>
        </div>

        <el-table :data="tableData" style="width: 100%; margin-top: 20px">
          <el-table-column
            label="会员手机号"
            prop="tel"
            width=""
          ></el-table-column>
          <el-table-column label="开通日期" prop="createTime"></el-table-column>
          <el-table-column
            label="结束日期"
            prop="dueTime"
            width=""
          ></el-table-column>
          <el-table-column
            label="管理员手机号"
            prop="adminTel"
            width=""
          ></el-table-column>
          <el-table-column label="备注" prop="notes" width=""></el-table-column>
          <el-table-column label="操作" prop="date" width="">
            <template slot-scope="{ row }">
              <el-button size="mini" @click="editMember(row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="searchInfo.pageNum"
          :page-size="searchInfo.pageSize"
          :page-sizes="[5, 10, 15, 20]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
        <!-- 开通会员弹出框-->
        <el-dialog
          :close-on-click-modal="false"
          :title="dialogTitle"
          :visible.sync="memberDialog"
          center
          width="420px"
        >
          <el-form ref="addFromRef" :model="fromData" label-width="90px">
            <el-form-item label="用户账号 : " prop="">
              <el-input
                v-model="inputTel"
                :disabled="isDisabled"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="dialogType === 1" label="订阅时长 : " prop="">
              <el-select
                v-model="selectTime"
                placeholder="请选择"
                style="width: 215px"
                @change="timeChange"
              >
                <el-option
                  v-for="(item, index) in priceList"
                  :key="item.id"
                  :disabled="item.packageStatus == 0"
                  :label="item.packageName"
                  :value="index"
                ></el-option>
              </el-select>
              <div v-if="priceList[selectTime]" class="price">
                {{ priceStr }}
              </div>
            </el-form-item>
            <el-form-item label="开通方式 : ">
              <el-select
                v-model="orderPayType"
                value-key=""
                placeholder=""
                filterable
                @change=""
              >
                <el-option label="易找标后台开通" :value="12"> </el-option>
                <el-option label="易找标后台转账" :value="26"> </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="dialogType === 2" label="结束时间 : " prop="">
              <el-date-picker
                v-model="dueTime"
                format="yyyy 年 MM 月 dd 日"
                placeholder="选择结束日期"
                style="width: 215px"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注 : " prop="">
              <el-input
                v-model="notes"
                :rows="4"
                placeholder="请输入内容"
                type="textarea"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="memberDialog = false">取 消</el-button>
            <el-button v-if="dialogType === 1" type="primary" @click="confirm"
              >确 定</el-button
            >
            <el-button v-else type="primary" @click="editConfirm"
              >修 改</el-button
            >
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-scrollbar>
</template>
<script>
export default {
  name: "backMember",
  data() {
    return {
      loading: false,
      inputTel: "",
      selectTime: 0,
      orderPayType: 12  ,
      priceList: [],
      memberDialog: false,
      searchInfo: {
        pageSize: 10,
        pageNum: 1,
        phoneNumber: "",
      },
      // 备注
      notes: "",
      // 管理员手机号
      adminTel: "",
      total: 0,
      tableData: [],
      fromData: {},
      addFromRules: {},
      isDisabled: false,
      dialogTitle: "添加",
      dueTime: "",
      userId: "",
      dialogType: 1, // 1：添加  2：修改
    };
  },
  created() {
    this.membersList();
  },
  watch: {
    memberDialog(newVal) {
      if (newVal) return;
      // this.$refs.addFromRef.resetField()
      this.inputTel = "";
      this.selectTime = 0;
      this.notes = "";
    },
  },
  mounted() {
    this.$request.computeSubscribePrice().then((res) => {
      if (res.status == 200) {
        this.priceList = res.data;
      }
    });
  },
  computed: {
    priceStr() {
      const priceObj = this.priceList[this.selectTime];
      return `（原价${priceObj.originalPrice / 100}元，现价${
        priceObj.realPrice / 100
      }）`;
    },
  },
  methods: {
    // 搜索按钮
    searchClick() {
      this.searchInfo.pageNum = 1;
      this.membersList();
    },
    // 打开弹窗
    openDialog() {
      this.dialogType = 1;
      this.isDisabled = false;
      this.dialogTitle = "添加";
      this.memberDialog = true;
    },
    // 修改按钮
    editMember({ dueTime, userid, tel, notes, adminTel }) {
      this.dialogType = 2;
      this.isDisabled = true;
      this.dialogTitle = "修改";
      this.memberDialog = true;

      this.inputTel = tel;
      this.dueTime = dueTime;
      this.userId = userid;
      this.notes = notes;
      this.adminTel = adminTel;
    },
    // 确定修改
    editConfirm() {
      this.editMembersDueTime();
    },
    // 会员列表
    async membersList() {
      let res = await this.$request.membersList(this.searchInfo);
      if (res.status === 200) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    },
    // 修改会员到期时间
    async editMembersDueTime() {
      let data = {
        tel: this.inputTel,
        userId: this.userId,
        dueTime: this.dueTime,
        notes: this.notes,
        adminPhone: this.$store.state.tel,
      };
      let res = await this.$request.editMembersDueTime(data);
      if (res.status === 200) {
        this.$message.success("修改成功");
        this.memberDialog = false;
      } else {
        this.$message.error(res.message);
      }
      await this.membersList();
    },
    handleSizeChange(val) {
      this.searchInfo.pageSize = val;
      this.membersList();
    },
    handleCurrentChange(val) {
      this.searchInfo.pageNum = val;
      this.membersList();
    },

    confirm() {
      if (this.utils.testPhoneNumber(this.inputTel)) {
        this.loading = true;
        this.$request
          .openMember({
            phoneNumber: this.inputTel,
            subscribeDiscountId: this.priceList[this.selectTime].id,
            adminPhone: this.$store.state.tel,
            orderPayType:this.orderPayType,
            notes: this.notes,
          })
          .then(
            (res) => {
              this.loading = false;
              if (res.status == 200) {
                this.inputTel = "";
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.memberDialog = false;
                this.membersList();
              } else {
                this.requestError(res.status, res.message);
              }
            },
            (err) => {
              this.loading = false;
              this.requestFail(err);
            }
          );
      } else {
        this.$message({
          type: "warning",
          message: "手机号格式不正确",
        });
      }
    },
    timeChange() {
      console.log(this.selectTime);
    },
  },
};
</script>

<style lang="less">
#page-back-member {
  .price {
    display: inline-block;
    margin-top: 10px;
  }

  .title {
    display: inline-block;
    vertical-align: middle;
    margin-top: 20px;
  }
}
</style>
